/** @jsxImportSource @emotion/react */
import {
  EuiButton,
  EuiButtonEmpty,
  EuiIcon,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiSpacer,
  EuiText,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { useProjectFolderContext } from "../folders/ProjectFoldersProvider";
import { css } from "@emotion/react";
import { DEFAULT_FOLDER_COLOR } from "components/ProjectTablesTable/ProjectTablesTable.helpers";
import { isNonNull } from "utils/isNonNull";
import { ProjectFolderDjango } from "../folders/ProjectFoldersProvider.api";
import { useProjectTablesTableContext } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";

interface ModalDeleteFolderProps {
  folder: ProjectFolderDjango;
  onClose: () => void;
}

export const ModalDeleteFolder = ({
  folder,
  onClose,
}: ModalDeleteFolderProps) => {
  const deleteFolder = useProjectFolderContext((s) => s.deleteFolder);
  const updateSortedAndFilteredTables = useProjectTablesTableContext(
    (s) => s.updateSortedAndFilteredTables,
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    const { error } = await deleteFolder({ folderId: folder.id });
    updateSortedAndFilteredTables();
    setIsLoading(false);

    if (error === undefined) {
      addUtilityToastSuccess("Folder deleted");
    } else {
      addUtilityToastFailure("Failed to delete folder");
    }

    onClose();
  };

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle component="h3">Delete Folder</EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiText>
          <p>
            Confirm you wish to delete this folder:
            <br />{" "}
            <span
              css={css`
                color: ${isNonNull(folder.color)
                  ? folder.color
                  : DEFAULT_FOLDER_COLOR};
              `}
            >
              <EuiIcon type={"folderOpen"} size="m" /> {folder.name}
            </span>{" "}
          </p>
          <p>This action cannot be undone.</p>
        </EuiText>
        <EuiSpacer />
      </EuiModalBody>
      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>
        <EuiButton
          isLoading={isLoading}
          fill
          color="danger"
          onClick={() => void handleSubmit()}
        >
          Delete
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  );
};
